import { Component, OnInit } from '@angular/core';
import { ExcelDataProvider } from 'src/app/_Core/_Providers/excel.provider';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { APIs } from 'src/app/config/api.constant';
import { ApiService } from 'src/app/services/api.service';
import { AppConstant } from 'src/app/config/app.constant';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-companies-rfid-bulkupload',
  templateUrl: './companies-rfid-bulkupload.component.html',
  styleUrls: ['./companies-rfid-bulkupload.component.scss']
})
export class CompaniesRfidBulkuploadComponent implements OnInit {

  success: boolean;
  templateUrl: any;
  url: string;
  token: string;
  allocatedCardCountDetails: any;
  baseUrl;

  constructor(
    private router: Router,
    private excelProvider: ExcelDataProvider,
    private activatedRoute: ActivatedRoute,
    private dataService: DataService,
    private apiService: ApiService,
  ) { }

  ngOnInit(): void {
    
    let parkId = localStorage.getItem("parkId") ?? 1;
    this.baseUrl = `${environment.apiBaseUrl}api/BlobStorage/DownloadTemplateFile?fileName=MemberCard_Bulk_Upload.xlsx`;

    this.activatedRoute.queryParams.subscribe((res) => {
      this.success = res?.sucess ? res?.sucess : false;
    });

    this.token = 'Bearer' + ' ' + localStorage.getItem(AppConstant.localStorage.token);
    this.tenantMemberAllocatedCard();
  }

  handleFileSelect(evt) {
    var files = evt.target.files;
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json
      .parseExcel(files[0])
      .then((data) => {
        // this.prepareTableData(JSON.parse(data));
        this.dataService.setExcelData(data);
        this.router.navigateByUrl('companies-rfid-bulkupload-preview');
      })
      .catch((err) => {
        console.log('Failed to read excel ', err);
      });
  }

  tenantMemberAllocatedCard() {
    let tenantId = 0;
    let parkId = localStorage.getItem("parkId") ?? 1;
    // this.url = APIs.tenantMemebrAllocatedCardCount + '/' + tenantId;
    this.url = APIs.tenantMemebrAllocatedCardCount + '?tenantId=' + tenantId + '&parkId=' + parkId;
    const header = {
      Authorization: this.token,
    };
    this.apiService.get(this.url, '', header).subscribe(
      (response: any) => {
        console.log(response);
        this.allocatedCardCountDetails = response;
      },
      (err) => console.log('error', err)
    );
  }

}
